import { useEffect } from 'react';

export function useDocumentTitle(title) {
  useEffect(() => {
    document.title = title ?? 'IR3';
  }, [title]);

  return null;
}
